<template>
  <div id="app">
    <apn-header />
    <!-- <router-link v-if="subscribe" class="subscribe-banner" to="/subscribe">apply now</router-link> -->
    <transition>
        <router-view/>
    </transition>
    <!-- <router-link v-if="subscribe" class="btn--subscribe" to="/subscribe">apply now</router-link> -->
  </div>
</template>

<script>
export default {
    name: 'app',
    data() {
        return {
            subscribe: true,
        }
    },
    watch: {
        '$route'(to) {
            if (to.name == 'subscribe') this.subscribe = false
            else this.subscribe = true
        }
    },
    mounted() {
        if (this.$route.name == 'subscribe') this.subscribe = false
        else this.subscribe = true
        console.log('GTag', gtag);
        console.log('Windows.GTag', window.gtag);
    }
}
</script>

<style lang="scss">
:root {
    --header-color: #333;
    --body-color: #515151;
    --primary: #00aeef;
    --secondary: #63c2e1;
    --main-bg: #fff;
    --theme-bg: #f0f5f7;
    --footer-bg: #025876;
    --custom-ease: cubic-bezier(0.62, 0.28, 0.23, 0.99);
    --max-width: 1200px;
    --header-height: 60px;
    @media (min-width: 992px) {
        --header-height: 80px;
    }
}

html,
body {
    margin: 0;
    padding: 0;
    width: 100%;
    min-height: 101vh;
    // overflow: hidden;
    background-color: var(--main-bg);
    #app {
        font-family: 'Roboto', 'Padauk', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: var(--body-color);
        font-size: 16px;
    }
    * {
        box-sizing: border-box;
        font-family: 'Roboto', 'Padauk', sans-serif;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0;
        padding: 10px 0;
        color: var(--header-color);
        font-family: 'Roboto', sans-serif;
    }
    p {
        margin: 0;
        padding: 10px 0;
        color: var(--body-color);
        font-weight: 300;
        line-height: 24px;
    }
    button {
        border: none;
        background-color: transparent;
        outline: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin: 0;
        padding: 0;
        cursor: pointer;
    }
    .apn-container {
        width: 100%;
        max-width: var(--max-width);
        margin: 0 auto;
        padding: 0 10px;
    }
}

.subscribe-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    margin-top: var(--header-height);
    background: #D60564;
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
    text-decoration: none;
}

.btn--subscribe {
    position: fixed;
    z-index: 99;
    top: 40%;
    right: 0;
    background-color: #333;
    color: #fff;
    width: 120px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    text-decoration: none;
    font-weight: 600;
    transform-origin: bottom right;
    transform: translate(0, -50%) rotate(-90deg);
    border-radius: 4px 4px 0 0;
    box-shadow: -2px 3px 6px rgba(0,0,0,0.16), -2px 3px 6px rgba(0,0,0,0.23);
    @media (min-width: 992px) {
        width: 150px;
        height: 38px;
    }
}

// APN Button
.apn-btn--more {
    width: 150px;
    height: 45px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
    background-color: transparent;
    border-radius: 40px;
    color: #fff;
    text-transform: uppercase;
    position: relative;
    z-index: 1;
    overflow: hidden;
    &::before,
    &::after {
        content: '';
        display: block;
        width: 100%;
        height: 50%;
        position: absolute;
        z-index: -1;
        background-color: var(--primary);
        left: 0;
        top: 0;
        transition: transform .2s ease;
    }
    &::after {
        top: initial;
        bottom: 0;
    }
    &:hover {
        border: 1px solid var(--primary);
        color: var(--primary);
        &::before {
            transform: translate(0, -102%);
        }
        &::after {
            transform: translate(0, 102%);
        }
    }
}

.apn-page {
    margin-top:  var(--header-height);
}
/* Page Animation */
.apn-page {
    // position: absolute;
    // z-index: 0;
    // left: 0;
    // right: 0;
    // top: 0;
    // bottom: 0;
    // overflow-x: hidden;
    // overflow-y: auto;
    // Delete later
    // padding-top: var(--header-height);
    // overflow-y: scroll; /* has to be scroll, not auto */
    // -webkit-overflow-scrolling: touch;
}

.v-leave-active {
    animation: onLeave 0.4s ease;
}
.v-enter-active {
    animation: onEnter 0.4s ease;
}
@keyframes onLeave {
    from {
        transform: translate(0, 0px);
        opacity: 1;
    }
    to {
        transform: translate(0, -140px);
        opacity: 0;
    }
}
@keyframes onEnter {
    from {
        transform: translate(0, 140px);
        opacity: 0;
    }
    to {
        transform: translate(0, 0px);
        opacity: 1;
    }
}

// Hooper
.hooper {
    outline: none;
    .hooper-pagination {
        .hooper-indicators {
            .hooper-indicator {
                height: 12px;
                width: 12px;
                background-color: transparent;
                position: relative;
                border: 1px solid #fff;
                border-radius: 100%;
                margin: 0 4px;
                &.is-active {
                    background-color: #fff;
                }
            }
        }
    }
    .hooper-navigation {
        .hooper-prev,
        .hooper-next {
            .icon {
                display: none;
            }
            @media (min-width: 1200px) {    
                &::before {
                    content: '';
                    display: block;
                    width: 42px;
                    height: 42px;
                    background-image: url(./assets/icons/arrow.svg);
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }
            }
        }
        .hooper-prev::before {
            transform: rotate(180deg);
        }
    }
}

// Vue Typer
.vue-typer {
    .char {
        color: var(--primary)!important;
    }
    .caret {
        background-color: var(--primary)!important;
        width: 2px !important;
    }
}

// Vue Select
.v-select {
    .vs__dropdown-toggle {
        border: 1px solid #aaa;
        min-height: 45px;
        padding-right: 4px;
        .vs__selected-options {
            .vs__selected {
                
            }
            input {
                color: #000;
            }
        }
        // .vs__actions {
        //     .vs__clear ,
        //     .vs__open-indicator {
        //         filter: var(--invert);
        //     }
        // }
    }
    .vs__dropdown-menu {     
        background-color: #fff;
        li {
            color: #333;
            height: 45px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .vs__dropdown-option--highlight {
            background: var(--theme-bg);
            color: #000;
        }
    }
}

/* Progress Bar */
#nprogress {
    pointer-events: none;
}
#nprogress .bar {
    background: var(--primary);
    position: fixed;
    z-index: 1031;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
}
#nprogress .peg {
    display: block;
    position: absolute;
    right: 0px;
    width: 100px;
    height: 100%;
    box-shadow: 0 0 10px var(--primary), 0 0 5px var(--primary);
    opacity: 1;
    -webkit-transform: rotate(3deg) translate(0px, -4px);
    -ms-transform: rotate(3deg) translate(0px, -4px);
    transform: rotate(3deg) translate(0px, -4px);
}
.nprogress-custom-parent {
    overflow: hidden;
    position: relative;
}
.nprogress-custom-parent #nprogress .bar {
    position: absolute;
}

// Loading
@keyframes lds-ellipsis3 {
    0%, 25% {
        left: 32px;
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    50% {
        left: 32px;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    75% {
        left: 100px;
    }
    100% {
        left: 168px;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}
@-webkit-keyframes lds-ellipsis3 {
    0%, 25% {
        left: 32px;
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    50% {
        left: 32px;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    75% {
        left: 100px;
    }
    100% {
        left: 168px;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    25%, 100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    }
    @-webkit-keyframes lds-ellipsis2 {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    25%, 100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }
}
@keyframes lds-ellipsis {
    0% {
        left: 32px;
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    25% {
        left: 32px;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    50% {
        left: 100px;
    }
    75% {
        left: 168px;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    100% {
        left: 168px;
        -webkit-transform: scale(0);
        transform: scale(0);
    }
}
@-webkit-keyframes lds-ellipsis {
    0% {
        left: 32px;
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    25% {
        left: 32px;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    50% {
        left: 100px;
    }
    75% {
        left: 168px;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    100% {
        left: 168px;
        -webkit-transform: scale(0);
        transform: scale(0);
    }
}
.lds-ellipsis {
    position: relative;
}
.lds-ellipsis > div {
    position: absolute;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 32px;
    height: 32px;
}
.lds-ellipsis div > div {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #f00;
    position: absolute;
    top: 100px;
    left: 32px;
    -webkit-animation: lds-ellipsis 1s cubic-bezier(0, 0.5, 0.5, 1) infinite forwards;
    animation: lds-ellipsis 1s cubic-bezier(0, 0.5, 0.5, 1) infinite forwards;
}
.lds-ellipsis div:nth-child(1) div {
    -webkit-animation: lds-ellipsis2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite forwards;
    animation: lds-ellipsis2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite forwards;
    background: #35b9e7;
}
.lds-ellipsis div:nth-child(2) div {
    -webkit-animation-delay: -0.5s;
    animation-delay: -0.5s;
    background: #35b9e7;
}
.lds-ellipsis div:nth-child(3) div {
    -webkit-animation-delay: -0.25s;
    animation-delay: -0.25s;
    background: #35b9e7;
}
.lds-ellipsis div:nth-child(4) div {
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
    background: #35b9e7;
}
.lds-ellipsis div:nth-child(5) div {
    -webkit-animation: lds-ellipsis3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite forwards;
    animation: lds-ellipsis3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite forwards;
    background: #35b9e7;
}
.lds-ellipsis {
    width: 200px !important;
    height: 200px !important;
    -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
    transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
}

</style>
